import config from '../../../../config';
import { GenerateLicenseModel, GenerateLicenseModelApi } from '../../../domainModels/licences/GenerateLicense';
import { LicenseModel, LicenseModelApi } from '../../../domainModels/licences/LicenseModel';
import {
    mapUpdateLicenseToApiModel,
    UpdateLicenseApiModel,
    UpdateLicenseModel,
} from '../../../domainModels/licences/UpdateLicense';
import { createHTMLAnchorFromResponse } from '../../../services/fileDownload';
import { axiosInstance as axios } from '../../axios/axiosInstance';
import { generateLicenseModelToApi } from './mappings/generateLicenseModelToApi';
import { mapApiLicenseModel } from './mappings/mapApiLicenseModel';

export const licensesEndpoint = `${config.tachoAPI.url}/Licenses`;

export const getLicenses = (): Promise<Array<LicenseModel>> => {
    return axios
        .get<Array<LicenseModelApi>>(licensesEndpoint)
        .then((response: { data: Array<LicenseModelApi> }) => {
            return response.data.map(item => mapApiLicenseModel(item));
        })
        .catch((err: string) => {
            throw Error(getLicenses.name + err);
        });
};

export const generateLicense = (newLicense: GenerateLicenseModel): Promise<GenerateLicenseModel> => {
    const mappedLicenseToGenerate = generateLicenseModelToApi(newLicense);
    return axios
        .post<GenerateLicenseModelApi>(licensesEndpoint, mappedLicenseToGenerate)
        .then(() => {
            return newLicense;
        })
        .catch((error: string) => {
            throw Error(generateLicense.name + error);
        });
};

export const removeLicense = (licenseNumber: string): Promise<string> => {
    return axios
        .delete<string>(`${licensesEndpoint}/${licenseNumber}`)
        .then(() => {
            return licenseNumber;
        })
        .catch((error: string) => {
            throw Error(removeLicense.name + error);
        });
};

export const updateLicense = (updatedLicense: UpdateLicenseModel, licenseNumber: string): Promise<UpdateLicenseModel> => {
    const mappedLicense = mapUpdateLicenseToApiModel(updatedLicense);
    return axios
        .patch<UpdateLicenseApiModel>(`${licensesEndpoint}/${licenseNumber}`, mappedLicense)
        .then(() => {
            return updatedLicense;
        })
        .catch((error: string) => {
            throw Error(updateLicense.name + error);
        });
};

export const downloadLicense = (licenseNumber: string): Promise<HTMLAnchorElement> => {
    return axios
        .get<any>(`${licensesEndpoint}/${licenseNumber}`)
        .then((response: any) => {
            return createHTMLAnchorFromResponse(response, true);
        })
        .catch((err: string) => {
            throw Error(getLicenses.name + err);
        });
};

export const getLicenseToken = (licenseNumber: string, licenseVersionId: string): Promise<any> => {
    return axios
        .get<string>(`${licensesEndpoint}/${licenseNumber}/${licenseVersionId}/Get-Token`)
        .then((response: { data: string }) => {
            return response.data;
        })
        .catch((err: string) => {
            throw Error(getLicenses.name + err);
        });
};

export const sendExistingLicenseViaEmail = (licenseNumber: string): Promise<boolean> => {
    return axios
        .post(`${licensesEndpoint}/${licenseNumber}/Send-To-Client`)
        .then(() => {
            return true;
        })
        .catch((error: string) => {
            throw Error(sendExistingLicenseViaEmail.name + error);
        });
};

export const allowCarStatusCounterReset = (licenseNumber: string): Promise<boolean> => {
    return axios
        .post(`${licensesEndpoint}/${licenseNumber}/AllowCarStatusCounterReset`)
        .then(() => {
            return true;
        })
        .catch((error: string) => {
            throw Error(allowCarStatusCounterReset.name + error);
        });
};

export const allowCarStatusCounterResetWithLimit = (licenseNumber: string, limit: number): Promise<boolean> => {
    return axios
        .post(`${licensesEndpoint}/${licenseNumber}/AllowCarStatusCounterResetWithLimit`, {
            CarStatusCounterLimit: limit,
        })
        .then(() => {
            return true;
        })
        .catch((error: string) => {
            throw Error(allowCarStatusCounterReset.name + error);
        });
};
